var SocialViewFaqs = {
  init: function() {
    var urlParams,
        loggedViewIDs = [],
        $collapseItems = $("#faqItems").find(".collapse"),
        $allLink = $("#faqToggleAllLink");

    $allLink.on("click", toggleAll);
    $collapseItems.on("shown.bs.collapse", onShow);
    $collapseItems.on("hidden.bs.collapse", onHide);

    parseUrlParams();

    if (urlParams.id) {
      pageLoadView(urlParams.id);
    }

    function parseUrlParams() {
      var match,
          pl     = /\+/g,  // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
          decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
          query  = window.location.search.substring(1);

      urlParams = {};
      while (match = search.exec(query))
         urlParams[decode(match[1])] = decode(match[2]);
    }

    function pageLoadView(id) {
      var $item = $("#faqCollapse_" + id),
        $li = $item.closest("li");

      setTimeout(function() {
        $li.addClass("-highlight");

        setTimeout(function() {
          $li.removeClass("-highlight")
        }, 3000);
      }, 200);

      $item.collapse("show");
    }

    function toggleAll() {
      isAllOpen() ? hideAll() : showAll();
    }

    function updateAllLink() {
      if (isAllOpen()) {
        $allLink.text(Labels.getLabel("Hide all"));
      } else {
        $allLink.text(Labels.getLabel("Show all"));
      }
    }

    function isAllOpen() {
      return $collapseItems.length == $collapseItems.filter(".in").length;
    }

    function onShow() {
      var id = $(this).attr("id");
      id = id.substring(id.indexOf("_") + 1);

      if (loggedViewIDs.indexOf(id) == -1) {
        loggedViewIDs.push(id);
        logView(id);
      }

      updateAllLink();
    }

    function onHide() {
      updateAllLink();
    }

    function showAll() {
      $collapseItems.collapse("show");
      updateAllLink();
    }

    function hideAll() {
      $collapseItems.collapse("hide");
      updateAllLink();
    }

    function logView(id) {
      var $item = $("#faqCollapse_" + id);

      var data = {
        action: "VIEWFAQ",
        description: $item.find(".collapse-list__title").text(),
        docid: id,
        accessmethod: sessionStorage.getItem("accessmethod")
      };

      RA.logAction(data);
    }
  }
};